<template>
	<div>
		<button
			v-for="item in list"
			:key="item.name"
			class="button is-list-item flex w-full px-1 py-2 control-panel-li button-senceli"
			:disabled="!canBeAdded(item)"
			@click="addPanel(item)"
		>
			<div class="w-16 text-5xl mr-2">
				<FontAwesomeIcon
					:icon="item.icon"
					v-bind="item.iconSettings"
					fixed-width
				/>
			</div>
			<div class="text-left panel-li-r">
				<div>
				
						{{ item.name }}
				
				</div>
				<div>
					<div>{{ item.description }}</div>
					<!-- <i class="el-icon-arrow-right"></i> -->
					
				</div>
			</div>
		</button>
	</div>
</template>

<script>
const PANELS_INFO = [
	{
		name: '水平布局',
		description: '并排放置更多面板',
		icon: 'columns',
		iconSettings: {},
		type: 'Grid',
		maxDepth: 2,
		defaults() {
			return {
				direction: 'row'
			}
		}
	},
	{
		name: '垂直布局',
		description: '竖排放置更多面板',
		icon: 'columns',
		iconSettings: {
			rotation: 270
		},
		type: 'Grid',
		maxDepth: 2,
		defaults() {
			return {
				direction: 'column'
			}
		}
	},
	{
		name: '场景切换器',
		description: '切换当前场景',
		icon: 'tv',
		iconSettings: {},
		type: 'Scenes'
	},
	{
		name: '信号源列表',
		description: '打开和关闭信号源',
		icon: 'video',
		iconSettings: {},
		type: 'Sources'
	},
	{
		name: '音频设备',
		description: '打开和关闭音频设备以及调节音量',
		icon: 'volume-up',
		iconSettings: {},
		type: 'Mixer'
	},
	{
		name: '设置转场',
		description: '设置当前转场',
		icon: 'chart-bar',
		iconSettings: {},
		type: 'Transitions'
	},
	{
		name: '设置转场持续时间',
		description: '设置当前转场持续时间',
		icon: 'clock',
		iconSettings: {},
		type: 'Durations'
	},
	{
		name: '推流录制控制',
		description: '控制推流和录制状态',
		icon: 'dot-circle',
		iconSettings: {},
		type: 'Stream'
	},
	{
		name: '网页嵌入',
		description: '嵌入任何网页',
		icon: 'window-maximize',
		iconSettings: {},
		type: 'Iframe'
	}
]

export default {
	props: {
		parentId: {
			type: [Number, String],
			required: true
		},
		parentDepth: {
			type: Number,
			required: true
		}
	},
	computed: {
		list() {
			return PANELS_INFO
		}
	},
	methods: {
		addPanel(item) {
			if (!this.canBeAdded(item)) {
				return
			}

			this.$store.dispatch('layout/addPanel', {
				type: item.type,
				parent: this.parentId,
				settings: item.defaults ? item.defaults() : {}
			})
			this.$emit('close')
		},
		canBeAdded(item) {
			if (item.maxDepth) {
				return this.parentDepth < item.maxDepth
			}

			return true
		}
	}
}
</script>
